import { ICONS } from "src/assests";
import Button from "./Button";
import Modal from "./Modal";

interface DeleteItemModalProps {
  isOpen: boolean;
  onClose: () => void;
  itemType: string;
  onDelete: () => void;
  isDeletingItem: boolean;
}

const DeleteItemModal = ({ isOpen, onClose, itemType, onDelete, isDeletingItem }: DeleteItemModalProps) => {

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="w-[381px] px-8 py-4"
      showCloseIcon={false}
    >
      <div className="flex items-center justify-center bg-gray-100 flex-col">
        <div className="bg-white flex flex-col items-center">
          <div>
            <img
              className="h-[82px] w-[82px] mt-2"
              src={ICONS.DeleteIconRed}
              alt="Delete Icon"
            />
          </div>
          <div className="mt-4">
            <h1 className="text-xl text-center">Delete {itemType}</h1>
            <p className="text-xs text-center text-[#666666] mt-1">
              {`Are you sure you want to delete this ${itemType}? Deleting it will
                    result in the removal of all associated information!`}
            </p>
          </div>
          <div className="flex gap-3 mt-4">
            <div className="flex justify-center my-4">
              <Button
                variant="secondary"
                onClick={onClose}
              >
                Cancel
              </Button>
            </div>

            <div className="flex justify-center my-4">
              <Button
                isLoading={isDeletingItem}
                onClick={onDelete}
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteItemModal;
